<template>
  <div class="portada-xv" ref="rootRef" aria-label="Corte de Honor y Padrinos">
    <!-- ⚜️ ELEMENTOS DE ESQUINA DECORATIVOS -->
    <img src="@/assets/esq1.png" ref="elemTLRef" class="esquina esquina-tl" alt="" />
    <img src="@/assets/esq1.png" ref="elemBRRef" class="esquina esquina-br" alt="" />

    <!-- 🦋 MARIPOSAS ANIMADAS -->
    <img :src="mariposaImg" ref="mariposa1Ref" class="mariposa-fija mariposa-1" alt="" />
    <img :src="mariposaImg" ref="mariposa2Ref" class="mariposa-fija mariposa-2" alt="" />

    <!-- CONTENIDO PRINCIPAL -->
    <div class="contenido-cortes">
      
      <!-- 👑 SECCIÓN 1: CHAMBELÁN DE HONOR -->
      <section class="seccion-bloque" ref="bloqueChambelanRef">
        <div class="titulo-damas-container">
          <img :src="mariposaImg" class="mariposa-titulo" alt="" />
          <h2 class="honor-texto">Chambelán de Honor</h2>
          <img :src="mariposaImg" class="mariposa-titulo espejo" alt="" />
        </div>
        <div class="separador-elegante"></div>
        <ul class="lista-nombres">
          <li class="nombre-destacado">Luis Huerta</li>
        </ul>
      </section>

      <!-- 💃🕺 SECCIÓN 2: DAMAS Y CHAMBELANES -->
      <section class="seccion-bloque" ref="bloqueParejasRef">
        <div class="titulo-damas-container">
          <img :src="mariposaImg" class="mariposa-titulo" alt="" />
          <h2 class="honor-texto">Damas y Chambelanes</h2>
          <img :src="mariposaImg" class="mariposa-titulo espejo" alt="" />
        </div>
        <div class="separador-elegante"></div>
        <ul class="lista-nombres dos-columnas">

          <li>Sujey y Darwin</li>
          <li>Lindsay y Ronni</li>
          <li>Sophia y Fernando</li>
          <li>Siomara y Jesús</li>
          <li>Jemely y Armando</li>
        </ul>
      </section>

      <!-- 🎁 SECCIÓN 3: PADRINOS DE REGALOS -->
      <section class="seccion-bloque" ref="bloquePadrinosRef">
        <div class="titulo-damas-container">
          <img :src="mariposaImg" class="mariposa-titulo" alt="" />
          <h2 class="honor-texto">Padrinos de Regalos</h2>
          <img :src="mariposaImg" class="mariposa-titulo espejo" alt="" />
        </div>
        <div class="separador-elegante"></div>
        <ul class="lista-nombres padrinos-grid">
                              <li>Marisol Rivas</li>

          <li>Evelin Guerrero</li>
          <li>Ana Garay</li>
          <li>Karen Hernández</li>
          <li>Vanessa Hernández</li>
          
          <li>Grecia Martínez</li>
          <li>Dany Molina</li>
          <li>Vanessa Ramírez</li>
          <li>Carolina Ramírez</li>
          <li>Brenda Aguilera</li>
          <li>Génesis Aguilera</li>
          <li>Olga Palacios</li>
          <li>Luz Meléndez</li>
          <li>Maricela Meléndez</li>
          <li>Mabel Aguilera</li>
          <li>Margarita, Rebeka, María Sandoval</li>
          <li>Kevin, Walter Guerrero</li>
          <li>Arely Escamilla</li>
          <li>Esmeralda Guerrero</li>
          <li>Melliza Rodríguez</li>
        </ul>
      </section>

    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'

// Registrar ScrollTrigger en GSAP
gsap.registerPlugin(ScrollTrigger)

// Importar la imagen de la mariposa
import mariposaImg from '@/assets/mariposa.png'

export default {
  name: 'PortadaArley',
  setup() {
    const rootRef = ref(null)
    const elemTLRef = ref(null)
    const elemBRRef = ref(null)

    const mariposa1Ref = ref(null)
    const mariposa2Ref = ref(null)

    // Referencias para las secciones con animación ScrollTrigger
    const bloqueChambelanRef = ref(null)
    const bloqueParejasRef = ref(null)
    const bloquePadrinosRef = ref(null)

    onMounted(() => {
      // ---------------------------------------------------------
      // 0. ESTADO INICIAL
      // ---------------------------------------------------------
      gsap.set([elemTLRef.value, elemBRRef.value].filter(Boolean), {
        opacity: 0,
        clipPath: 'polygon(0% 0%, 0% 0%, 0% 0%, 0% 0%)'
      })

      gsap.set([mariposa1Ref.value, mariposa2Ref.value], {
        opacity: 0,
        transformPerspective: 800,
        transformOrigin: "center center"
      })

      // ---------------------------------------------------------
      // 1. ANIMACIÓN DE ENTRADA DE ESQUINAS Y MARIPOSAS PRINCIPALES
      // ---------------------------------------------------------
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: rootRef.value,
          start: 'top 80%',
          toggleActions: 'play none none none'
        }
      })

      tl.to([elemTLRef.value, elemBRRef.value].filter(Boolean), {
        clipPath: 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)',
        opacity: 0.85,
        duration: 1.6,
        ease: 'power2.inOut'
      })
      .to([mariposa1Ref.value, mariposa2Ref.value], {
        opacity: 0.85,
        duration: 1.4,
        ease: 'power2.out'
      }, "-=1.2")

      // ---------------------------------------------------------
      // 2. ANIMACIÓN EN CASCADA AL HACER SCROLL (VIEWPORT)
      // ---------------------------------------------------------
      const bloques = [
        bloqueChambelanRef.value,
        bloqueParejasRef.value,
        bloquePadrinosRef.value
      ].filter(Boolean)

      bloques.forEach((bloque) => {
        gsap.from(bloque, {
          scrollTrigger: {
            trigger: bloque,
            start: 'top 85%',
            toggleActions: 'play none none none'
          },
          opacity: 0,
          y: 40,
          duration: 1,
          ease: 'power3.out'
        })
      })

      // ---------------------------------------------------------
      // 🦋 3. ANIMACIÓN DE ALETEO SÚPER FINO Y DELICADO
      // ---------------------------------------------------------
      gsap.to(mariposa1Ref.value, {
        rotateY: 15,
        scaleX: 0.8,
        duration: 0.8,
        repeat: -1,
        yoyo: true,
        ease: 'sine.inOut'
      })
      gsap.to(mariposa1Ref.value, {
        y: '-=3',
        x: '+=3',
        rotation: '-=2',
        duration: 0.9,
        repeat: -1,
        yoyo: true,
        ease: 'sine.inOut'
      })

      gsap.to(mariposa2Ref.value, {
        rotateY: -25,
        scaleX: 0.9,
        duration: 0.5,
        repeat: -1,
        yoyo: true,
        ease: 'sine.inOut',
        delay: 0.4
      })
      gsap.to(mariposa2Ref.value, {
        y: '+=7',
        x: '-=4',
        rotation: '+=2.5',
        duration: 4.0,
        repeat: -1,
        yoyo: true,
        ease: 'sine.inOut'
      })
    })

    return {
      rootRef,
      elemTLRef,
      elemBRRef,
      mariposa1Ref,
      mariposa2Ref,
      bloqueChambelanRef,
      bloqueParejasRef,
      bloquePadrinosRef,
      mariposaImg
    }
  }
}
</script>

<style scoped>
.portada-xv {
  position: relative;
  width: 100%;
  min-height: 100vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  background: radial-gradient(circle at center, #6d0a14 0%, #3e0409 100%);
  padding: 56px 16px 64px;
}

.contenido-cortes {
  width: 100%;
  max-width: 650px;
  display: flex;
  flex-direction: column;
  gap: 48px;
  z-index: 2;
}

/* ⚜️ ESQUINAS DECORATIVAS */
.esquina {
  position: absolute;
  width: min(40vw, 180px);
  height: auto;
  pointer-events: none;
  z-index: 5;
}

.esquina-tl {
  top: 0;
  left: 0;
}

.esquina-br {
  bottom: 0;
  right: 0;
  transform: scaleX(-1) scaleY(-1);
}

/* 🦋 MARIPOSAS FIJAS CON ALETEO */
.mariposa-fija {
  position: absolute;
  width: min(14vw, 55px);
  height: auto;
  pointer-events: none;
  z-index: 6;
  transform-style: preserve-3d;
  will-change: transform;
}

.mariposa-1 {
  top: 15%;
  right: 10%;
  transform: rotate(-15deg);
}

.mariposa-2 {
  bottom: 10%;
  left: 8%;
  transform: rotate(18deg);
}

/* SECCIONES Y BLOQUES */
.seccion-bloque {
  text-align: center;
  padding: 0 12px;
}

.titulo-damas-container {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin-top: 10px;
}

.mariposa-titulo {
  width: 28px;
  height: auto;
  transform-style: preserve-3d;
  will-change: transform;
}

.mariposa-titulo.espejo {
  transform: scaleX(-1);
}

.separador-elegante {
  width: 110px;
  height: 2px;
  margin: 12px auto 18px;
  background: linear-gradient(90deg, transparent, #d9b7c6, transparent);
  border-radius: 2px;
}

.honor-texto {
  font-family: 'CynthiaJuneJF', cursive;
  font-size: clamp(1.9rem, 7vw, 2.4rem);
  display: block;
  line-height: 1.1;
  color: #fafafa;
  margin: 0;
}

/* LISTAS DE NOMBRES */
.lista-nombres {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.lista-nombres li {
  font-size: clamp(1.1rem, 3.8vw, 1.25rem);
  color: #B28F60;
  letter-spacing: 0.5px;
}

.nombre-destacado {
  font-size: clamp(1.85rem, 5.2vw, 1.6rem) !important;
  color: #B28F60;
    font-family: 'ludovica', cursive;

  font-weight: bold;
}

/* Estilo elegante para listas largas o en dos columnas si pantallas grandes */
@media (min-width: 768px) {
  .padrinos-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 8px 16px;
    text-align: center;
  }
}
</style>